/* Reusable route guard for protected pages. Renders nothing until the sign-in check
resolves, so protected content never flashes before an unauthenticated user is redirected.
This is a UX guard only - the backend middleware (requireAuth/requireSpecificAuth) is the
real security boundary. */

import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { checkIfSignedIn } from '../../helper_methods/signinCheck.js';
import LoadingWheel from './LoadingWheel.js';

export default function RequireAuth({ children }) {
    const [status, setStatus] = useState('checking'); // 'checking' | 'allowed' | 'denied'

    useEffect(() => {
        let active = true;
        checkIfSignedIn()
            .then((signedIn) => { if (active) setStatus(signedIn === true ? 'allowed' : 'denied'); })
            .catch(() => { if (active) setStatus('denied'); });
        return () => { active = false; };
    }, []);

    if (status === 'checking') return <LoadingWheel />; // wheel (not protected content) while we check
    if (status === 'denied') return <Navigate to="/signin" replace />;
    return children;
}
